import React from 'react';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import OutsourcedIOBLineItemDetailSearchParams from './OutsourcedIOBLineItemDetailSearchParams';
import OutsourcedIOBLineItemDetailService from '../../../Services/OutsourcedIOBLineItemDetailService';
import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum';
import OutsourcedIOBLineItemDetailItem from '../../../Domain/OutsourcedIOBLineItemDetailItem';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import FigmaButtonRow from '../../../Elements/FigmaButtonRow';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import IconPositionEnum from '../../../Enums/IconPositionEnum';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import EditOutsourcedIOBLineItemDetailWindowDescription from './EditOutsourcedIOBLineItemDetailWindowDescription';
import RepeatOutsourcedIOBLineItemDetailWindowDescription from './RepeatOutsourcedIOBLineItemDetailWindowDescription';
import ErrorMessage from '../../../Elements/ErrorMessage';
import dateTimeHelper from '../../../Helpers/datetimeHelper';
import OutsourcedStatusEnum from '../../../Enums/OutsourcedStatusEnum';
import AuthService from '../../../Services/authService';

class OutsourcedIOBLineItemDetailAdmin extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      searchItem: new OutsourcedIOBLineItemDetailSearchParams(),
      shownPanel: ShownPanelsEnum.None,
      itemList: [],
      numberOfElementsInTheTable: 0,
      selectedItem: {},
      allItemsInTheSearchSetAreSelected: false,
    };

    this.refresh = this.refresh.bind(this);
    this.startSearch = this.startSearch.bind(this);

    OutsourcedIOBLineItemDetailItem.editFunction = this.editFunction.bind(this);
    OutsourcedIOBLineItemDetailItem.repeatFunction = this.repeatFunction.bind(this);
    OutsourcedIOBLineItemDetailItem.markAsUninvoiceableFunction = this.markAsUninvoiceableFunction.bind(this);
    OutsourcedIOBLineItemDetailItem.markAsInvoiceableFunction = this.markAsInvoiceableFunction.bind(this);
    OutsourcedIOBLineItemDetailItem.fwApproveFunction = this.fwApproveForItem.bind(this);
    OutsourcedIOBLineItemDetailItem.osApproveFunction = this.osApproveForItem.bind(this);
  }

  editFunction(id, item) {
    item.SurveyId = item.SurveyId ? `${item.SurveyId}//${item.ClientId}` : null;
    item.TpSurveyId = item.TpSurveyId ? `${item.TpSurveyId}//${item.ClientId}` : null;
    item.ThirdPartySource = item.ThirdPartySource === 'Any' ? null : item.ThirdPartySource;
    this.setState({
      selectedItem: item,
      shownPanel: ShownPanelsEnum.EditItem,
    });
  }

  repeatFunction(id, item) {
    this.setState({
      selectedItem: {
        OutsourcedIOBLineItemDetailId: id,
        StartDate: new Date(),
        EndDate: new Date(),
        ExpectedRepeats: `${dateTimeHelper.toYYYYsMMsDD(new Date())}\nTotal: 1`,
        PeriodMonth: 1,
      },
      shownPanel: ShownPanelsEnum.Repeat,
    });
  }

  markAsUninvoiceableFunction(id) {
    ErrorMessage.SetApprove('Are you sure you want to mark this IOB Line Item Detail as Uninvoiceable?', () =>
      this.markAsUninvoiceableFunctionInner(id)
    );
  }

  markAsUninvoiceableFunctionInner(id) {
    OutsourcedIOBLineItemDetailService.MarkAsUninvoiceable(id)
      .then(() => this.refresh())
      .catch((error) => ErrorMessage.SetErrorMessage('OLIA_MU', error));
  }

  markAsInvoiceableFunction(id) {
    ErrorMessage.SetApprove('Are you sure you want to mark this IOB Line Item Detail as Invoiceable?', () =>
      this.markAsInvoiceableFunctionInner(id)
    );
  }

  markAsInvoiceableFunctionInner(id) {
    OutsourcedIOBLineItemDetailService.MarkAsInvoiceable(id)
      .then(() => this.refresh())
      .catch((error) => ErrorMessage.SetErrorMessage('OLIA_MI', error));
  }

  collectTimeBasedLineItems() {
    OutsourcedIOBLineItemDetailService.CollectTimeBasedLineItems()
      .then(() => {
        ErrorMessage.SetSuccess(
          'Time-Based Line Item collection has been triggered. The process will run in the background.'
        );
        this.refresh();
      })
      .catch((error) => ErrorMessage.SetErrorMessage('OLIA62', error));
  }

  refresh() {
    this.setState({ searchItem: { ...this.state.searchItem }, shownPanel: ShownPanelsEnum.None });
  }

  startSearch(searchItem) {
    this.setState({
      searchItem: { ...searchItem },
    });
  }

  changeOfItemListFunction(itemList, numberOfElementsInTheTable) {
    this.setState({
      itemList,
      numberOfElementsInTheTable,
    });
  }

  changeOfAllItemsAreSelectedFunction(allItemsInTheSearchSetAreSelected) {
    this.setState({ allItemsInTheSearchSetAreSelected });
  }

  getNumberOfSelectedElements() {
    return this.state.itemList.filter((x) => x.Selected).length;
  }

  fwApproveForItem(id) {
    ErrorMessage.SetApprove('Are you sure you want to approve this IOB Line Item Detail as the Bill To Office?', () =>
      this.approveInner([id], false, null, OutsourcedStatusEnum.ReadyForInvoicing)
    );
  }

  osApproveForItem(id) {
    ErrorMessage.SetApprove(
      'Are you sure you want to approve this IOB Line Item Detail as the Work Done By office?',
      () => this.approveInner([id], false, null, OutsourcedStatusEnum.ApprovedForInvoicing)
    );
  }

  fwApproveForSelected() {
    const count = this.getNumberOfSelectedElements();
    const message = this.state.allItemsInTheSearchSetAreSelected
      ? `Are you sure you want to approve all ${this.state.numberOfElementsInTheTable} items in the current list as the Bill To Office?`
      : `Are you sure you want to approve the ${count} selected item(s) as the Bill To Office?`;
    const ids = this.state.allItemsInTheSearchSetAreSelected
      ? []
      : this.state.itemList.filter((x) => x.Selected === true).map((x) => x.OutsourcedIOBLineItemDetailId);
    ErrorMessage.SetApprove(message, () =>
      this.approveInner(
        ids,
        this.state.allItemsInTheSearchSetAreSelected,
        this.state.searchItem,
        OutsourcedStatusEnum.ReadyForInvoicing
      )
    );
  }

  osApproveForSelected() {
    const count = this.getNumberOfSelectedElements();
    const message = this.state.allItemsInTheSearchSetAreSelected
      ? `Are you sure you want to approve all ${this.state.numberOfElementsInTheTable} items in the current list as the Work Done By office?`
      : `Are you sure you want to approve the ${count} selected item(s) as the Work Done By office?`;
    const ids = this.state.allItemsInTheSearchSetAreSelected
      ? []
      : this.state.itemList.filter((x) => x.Selected === true).map((x) => x.OutsourcedIOBLineItemDetailId);
    ErrorMessage.SetApprove(message, () =>
      this.approveInner(
        ids,
        this.state.allItemsInTheSearchSetAreSelected,
        this.state.searchItem,
        OutsourcedStatusEnum.ApprovedForInvoicing
      )
    );
  }

  approveInner(ids, allItemsSelected, searchItem, newStatus) {
    OutsourcedIOBLineItemDetailService.Approve(ids, allItemsSelected, searchItem, newStatus)
      .then(() => {
        ErrorMessage.SetSuccess('Approve completed successfully.');
        this.refresh();
      })
      .catch((error) => ErrorMessage.SetErrorMessage('OLIA_APP', error));
  }

  renderOnePanel = (panelId, content) => (this.state.shownPanel === panelId ? content : null);

  renderPanels() {
    return (
      <>
        {this.renderOnePanel(
          ShownPanelsEnum.AddNewItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={new OutsourcedIOBLineItemDetailItem()}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={() => this.refresh()}
            windowDescription={EditOutsourcedIOBLineItemDetailWindowDescription}
            errorCode='OLIA90'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.EditItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedItem}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={() => this.refresh()}
            windowDescription={EditOutsourcedIOBLineItemDetailWindowDescription}
            errorCode='OLIA101'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.Repeat,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedItem}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={() => this.refresh()}
            windowDescription={RepeatOutsourcedIOBLineItemDetailWindowDescription}
            errorCode='OLIA112'
          />
        )}
      </>
    );
  }

  renderButtonsAndPanels() {
    return (
      <>
        <FigmaButtonRow
          buttons={[
            {
              type: ButtonTypeEnum.NormalIconLeft,
              color: ButtonColorsEnum.Primary,
              iconPosition: IconPositionEnum.Left,
              onClick: () => this.setState({ shownPanel: ShownPanelsEnum.AddNewItem }),
              label: 'Create',
              tooltip: 'Create',
              roleKey: 'outsourced_ioblineitemdetails_edit',
              iconName: 'fa-solid fa-circle-plus',
            },
            {
              type: ButtonTypeEnum.ExtraLargeNormal,
              color: ButtonColorsEnum.Secondary,
              iconPosition: IconPositionEnum.Left,
              onClick: () => this.collectTimeBasedLineItems(),
              label: 'Collect Time-Based Lines',
              tooltip: 'Collect Time-Based Lines',
              roleKey: 'outsourced_ioblineitemdetails_edit',
              iconName: 'fa-solid fa-clock-rotate-left',
            },
            {
              type: ButtonTypeEnum.NormalNormal,
              color: ButtonColorsEnum.Primary,
              iconPosition: IconPositionEnum.Left,
              onClick: () => this.fwApproveForSelected(),
              label: 'Approve (Bill To Office)',
              tooltip: 'Approve selected items as the Bill To Office',
              roleKey: 'outsourced_ioblineitemdetails_edit',
              iconName: 'fa-solid fa-check',
              disabled:
                this.getNumberOfSelectedElements() === 0 ||
                this.state.itemList.some(
                  (x) =>
                    x.Selected &&
                    (x.Status !== OutsourcedStatusEnum.Collected ||
                      x.FieldworkOfficeId !== AuthService.getInstance().GetLoggedInUser()?.officeId)
                ),
            },
            {
              type: ButtonTypeEnum.NormalNormal,
              color: ButtonColorsEnum.Primary,
              iconPosition: IconPositionEnum.Left,
              onClick: () => this.osApproveForSelected(),
              label: 'Approve (Work Done By)',
              tooltip: 'Approve selected items as the Work Done By office',
              roleKey: 'outsourced_ioblineitemdetails_edit',
              iconName: 'fa-solid fa-check-double',
              disabled:
                this.getNumberOfSelectedElements() === 0 ||
                this.state.itemList.some(
                  (x) =>
                    x.Selected &&
                    (x.Status !== OutsourcedStatusEnum.ReadyForInvoicing ||
                      x.OutsourcingOfficeId !== AuthService.getInstance().GetLoggedInUser()?.officeId)
                ),
            },
          ]}
        />
        {this.renderPanels()}
      </>
    );
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderButtonsAndPanels()}
        <TabOfDataTable
          type={OutsourcedIOBLineItemDetailItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={OutsourcedIOBLineItemDetailService.GetList}
          convertDBItemsFunction={OutsourcedIOBLineItemDetailService.ConvertDBItem}
          searchItem={this.state.searchItem}
          searchParamsType={OutsourcedIOBLineItemDetailSearchParams}
          orderBy={'ApplyDate'}
          orderDirection={OrderDirectionsEnum.Desc}
          showSearchStrip={true}
          clickOnStartSearch={this.startSearch}
          itemList={this.state.itemList}
          changeOfItemListFunction={this.changeOfItemListFunction.bind(this)}
          changeOfAllItemsAreSelectedFunction={this.changeOfAllItemsAreSelectedFunction.bind(this)}
          errorCode='OLIA157'
        />
      </div>
    );
  }
}

export default OutsourcedIOBLineItemDetailAdmin;
